import styled, { css } from 'styled-components'

import { CircleBackground } from '@corabank/arco'

import { EmptyFileProps } from './interface'

const styleHoverAndActiveDrag = css`
  background-color: ${({ theme }) => theme.colors.graysGray3};
  color: ${({ theme }) => theme.colors.graysOffBlack};
`

export const FileUpload = styled.label<EmptyFileProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  width: 100%;
  padding: 0 24px;
  font-size: 1.6rem;
  line-height: 2.4rem;
  transition: background-color 0.2s, color 0.2s;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  border-radius: 16px;
  border-width: 2px;
  border-style: dashed;
  border-color: ${({ theme }) => theme.colors.graysGray3};
  background-color: ${({ theme }) => theme.colors.graysGray4};
  color: ${({ theme }) => theme.colors.graysGray1};

  &:hover,
  &:focus {
    ${styleHoverAndActiveDrag}
  }
`

export const FileUploadLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const FileUploadText = styled.p`
  color: inherit;
`

export const FileUploadIcon = styled(CircleBackground)`
  margin-right: 16px;
  line-height: initial;
`

export const FileUploadInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
`
